
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SwingTendency } from './types';
import CombinedDistancePieChart from './CombinedDistancePieChart';
import { DistanceData } from './types';

interface CombinedFairwayWoodChartProps {
  selectedLevel: string | null;
  tendencies: SwingTendency[];
}

const CombinedFairwayWoodChart: React.FC<CombinedFairwayWoodChartProps> = ({
  selectedLevel,
  tendencies
}) => {
  const { t } = useTranslation('common');
  const [distanceData, setDistanceData] = useState<DistanceData>({
    left: 0,
    center: 0,
    right: 0,
    total: 0,
    points: 0
  });
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Process tendencies to compile fairway wood stats
    const processFairwayWoodTendencies = () => {
      setLoading(true);
      
      // Filter tendencies by level if needed
      const filteredTendencies = tendencies.filter(t => 
        selectedLevel === null || t.test_level === selectedLevel
      );
      
      console.log(`Processing fairway wood tendencies, found:`, filteredTendencies.length);
      
      // Initialize counters
      let left = 0;
      let center = 0;
      let right = 0;
      let total = 0;
      let points = 0;
      
      // Process tendency data
      filteredTendencies.forEach(t => {
        if (t.tendency === 'left') {
          left += 1;
        } else if (t.tendency === 'center') {
          center += 1;
        } else if (t.tendency === 'right') {
          right += 1;
        }
        
        // Add points if they exist
        if (t.points) {
          points += t.points;
        }
        
        total += 1;
      });
      
      setDistanceData({ left, center, right, total, points });
      setLoading(false);
    };
    
    processFairwayWoodTendencies();
  }, [tendencies, selectedLevel]);
  
  return (
    <CombinedDistancePieChart
      title={t('swingTendencies.fairwayWoodPrecision')}
      distanceData={distanceData}
      loading={loading}
      borderColor="border-blue-500"
    />
  );
};

export default CombinedFairwayWoodChart;
